import { HeaderToolbar, Spinner } from "@xola/ui-kit";
import React, { useEffect, useState } from "react";
import { useIsFetching } from "react-query";
import { useDebounce } from "use-debounce";
import { useSearchAutoFocus } from "../../../hooks/useSearchAutoFocus";

interface ContactSearchProps {
    onSearchText: (value: string) => void;
}

export const ContactSearch = ({ onSearchText }: ContactSearchProps) => {
    const shouldAutoFocus = useSearchAutoFocus();
    const [search, setSearch] = useState("");
    const [debouncedSearch] = useDebounce(search.trim(), 500);
    const isFetching = useIsFetching(["users"]);

    useEffect(() => {
        onSearchText(debouncedSearch);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearch]);

    return (
        <span className="relative w-full flex-1">
            <HeaderToolbar.Search
                shouldHideMenu
                autoFocus={shouldAutoFocus}
                isLoading={!!isFetching}
                shouldStayOpen={false}
                placeholder="Search by name or email"
                onChange={setSearch}
            />
            {!!isFetching && <Spinner size="tiny" className="absolute top-2 right-4" />}
        </span>
    );
};
